export default __webpack_public_path__ + "static/media/EventsLayout.ee8c5bfe.png";